import React, { useState } from "react";
import Popup from "reactjs-popup";
import DynamicViewTable from "./DynamicViewTable";
import "./Form.css";
import { SERVER_URL } from "../config/config";
import {
  paymentStatementGroupInfo,
  paymentStatementDataObject,
  validate,
} from "../config/paymentStatementConfig.js";
import "./popup.css";
import "./ChallanForm.css";

const PaymentStatementForm = ({ sessionObject }) => {
  const [pageState, setPageState] = useState({
    ...paymentStatementDataObject,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
  });
  const [biltyInput, setBiltyInput] = useState("");
  const [biltyList, setBiltyList] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const [pageMode, setPageMode] = useState("write");
  const [popupError, setPopupError] = useState("");
  const [statements, setStatements] = useState([]);
  const [viewMode, setViewMode] = useState("create");

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const addBiltyId = async () => {
    if (!biltyInput.trim()) return;
    const fYear_fetch = JSON.parse(
      sessionStorage.getItem("financial_year_for_fetch")
    ).financial_year_for_fetch;
    const branchSuffix = sessionObject.sessionVariables.branch_suffix;

    try {
      let biltySuffix = branchSuffix;
      let biltyFyear = fYear_fetch;
      let companyId = pageState.company_id;

      const suffixResp = await fetch(`${SERVER_URL}/bilty/suffix_option`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bilty_no: parseInt(biltyInput.trim()),
          fyear: biltyFyear,
        }),
      });
      if (suffixResp.ok) {
        const suffixData = await suffixResp.json();
        if (suffixData.options && suffixData.options.length > 0) {
          biltySuffix = suffixData.options[0];
        }
      }

      if (biltySuffix === "" || biltySuffix === undefined || biltySuffix === null) {
        biltySuffix = "null";
      }

      const biltyResp = await fetch(
        `${SERVER_URL}/bilty/${parseInt(biltyInput.trim())}?suffix=${biltySuffix}&fyear=${biltyFyear}&companyId=${companyId}`
      );
      if (!biltyResp.ok) {
        alert("Invalid Bilty No");
        return;
      }
      const data = await biltyResp.json();
      if (biltyList.find((b) => b.bilty_id === data.bilty_id)) {
        alert("Bilty already added");
        return;
      }
      setBiltyList([
        ...biltyList,
        {
          bilty_id: data.bilty_id,
          bilty_no: data.bilty_no,
          consignor_name: data.consignor_name,
          consignee_name: data.consignee_name,
          total_amount: data.total_amount,
          no_of_package: data.no_of_package,
        },
      ]);
      setBiltyInput("");
    } catch (e) {
      alert("Error fetching bilty");
    }
  };

  const removeBilty = (index) => {
    setBiltyList(biltyList.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (biltyList.length === 0) {
      alert("Please add at least one bilty");
      return;
    }
    setOverlay(true);
    try {
      const response = await fetch(`${SERVER_URL}/payment_statement/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          created_by: parseInt(pageState.created_by),
          created_from: parseInt(pageState.created_from),
          bilty_ids: biltyList.map((b) => b.bilty_id),
          fyear: pageState.fYear,
          companyId: parseInt(pageState.company_id),
          statement_date: pageState.statement_date,
        }),
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Failed to create payment statement");
      }
      const result = await response.json();
      setPageState({
        ...pageState,
        statement_no: result.statement_no,
        id: result.id,
        bilty_ids: result.bilty_ids || [],
      });
      setPageMode("submitted");
    } catch (e) {
      setPopupError(e.message);
      setPageMode("error");
    } finally {
      setOverlay(false);
    }
  };

  const handleFetchStatements = async () => {
    setOverlay(true);
    try {
      const fYear_fetch = JSON.parse(
        sessionStorage.getItem("financial_year_for_fetch")
      ).financial_year_for_fetch;
      const url =
        `${SERVER_URL}/payment_statement/?created_from=${pageState.created_from}` +
        `&fyear=${fYear_fetch}&companyId=${pageState.company_id}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch statements");
      const data = await response.json();
      setStatements(data);
      setViewMode("list");
    } catch (e) {
      alert(e.message);
    } finally {
      setOverlay(false);
    }
  };

  const handleViewStatement = async (id) => {
    setOverlay(true);
    try {
      const response = await fetch(`${SERVER_URL}/payment_statement/${id}`);
      if (!response.ok) throw new Error("Failed to fetch statement");
      const data = await response.json();
      setPageState({
        ...pageState,
        statement_no: data.statement_no,
        statement_date: data.statement_date ? data.statement_date.split("T")[0] : "",
        id: data.id,
      });
      setBiltyList(
        (data.bilty_ids || []).map((bid) => ({ bilty_id: bid, bilty_no: "" }))
      );
      setViewMode("create");
      setPageMode("view");
    } catch (e) {
      alert(e.message);
    } finally {
      setOverlay(false);
    }
  };

  const statementColumns = [
    { Header: "Statement No", accessor: "statement_no" },
    { Header: "Date", accessor: "statement_date" },
  ];

  const biltyTableColumns = [
    { Header: "Bilty No", accessor: "bilty_no" },
    { Header: "Consignor", accessor: "consignor_name" },
    { Header: "Consignee", accessor: "consignee_name" },
    { Header: "Packages", accessor: "no_of_package" },
    { Header: "Amount", accessor: "total_amount" },
  ];

  return (
    <div className="item-master-form-container">
      {overlay && <div className="loading-overlay">Loading...</div>}
      <Popup
        open={pageMode == "submitted" || pageMode == "error"}
        modal
        contentStyle={contentStyle}
        closeOnDocumentClick={false}
      >
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">
              {pageMode == "submitted" ? (
                <div>Payment Statement Created Successfully</div>
              ) : (
                <div>Error In Payment Statement Module</div>
              )}
              <div>
                <a className="pop-up-close btn" onClick={close}>&times;</a>
              </div>
            </div>
            {pageMode == "submitted" ? (
              <div className="pop-up-content">
                Payment Statement created with No: {pageState.statement_no}
              </div>
            ) : (
              <div className="pop-up-content">
                <div className="pop-up-field">
                  <div className="pop-up-field-label">Error:</div>
                  <div className="pop-up-field-value">{popupError}</div>
                </div>
              </div>
            )}
            <div className="pop-up-actions">
              <button
                className="pop-up-button"
                onClick={() => {
                  if (pageMode == "submitted") {
                    setPageState({
                      ...paymentStatementDataObject,
                      created_from: String(sessionObject.sessionVariables.branch_id),
                      created_by: String(sessionObject.sessionVariables.user_id),
                      company_id: sessionObject.sessionVariables.company_id ?? "1",
                      fYear: sessionObject.sessionVariables.financial_year,
                    });
                    setBiltyList([]);
                    setPageMode("write");
                  } else {
                    setPageMode("write");
                  }
                  close();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </Popup>

      <div className="form-header">Payment Statement</div>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <button
          className="btn btn-primary"
          onClick={() => { setViewMode("create"); setPageMode("write"); }}
        >
          Create New
        </button>
        <button className="btn btn-primary" onClick={handleFetchStatements}>
          View Statements
        </button>
      </div>

      {viewMode === "create" && (
        <div className="form" noValidate>
          <div className="form-title">
            <div className="form-row">
              <label className="form-label">
                Statement No: {pageState.statement_no || "(New)"}
              </label>
            </div>
          </div>

          <div className="form-input-content-block-0">
            <div className="form-field-left">
              {paymentStatementGroupInfo["group-1"].map(function (info) {
                return (
                  <div className={info["className"]} key={info["name"]}>
                    <label className={info["labelClassName"]}>
                      {info["label"]}
                    </label>
                    <input
                      className={info["inputClassName"]}
                      name={info["name"]}
                      type={info["type"]}
                      placeholder={info["placeHolder"]}
                      value={pageState[info["name"]] || ""}
                      onChange={(e) =>
                        setPageState({ ...pageState, [e.target.name]: e.target.value })
                      }
                      disabled={pageMode == "view" ? "disabled" : ""}
                    />
                  </div>
                );
              })}
            </div>
            <div className="form-field-right">
              <div className="form-row">
                <label className="form-label">Add Bilty No</label>
                <input
                  className="form-input"
                  name="bilty_no_input"
                  type="text"
                  placeholder="Enter bilty no and press Enter"
                  value={biltyInput}
                  onChange={(e) => setBiltyInput(e.target.value)}
                  onKeyPress={(e) => { if (e.key === "Enter") addBiltyId(); }}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <h4>Added Biltys ({biltyList.length})</h4>
            <table className="table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Bilty No</th>
                  <th>Consignor</th>
                  <th>Consignee</th>
                  <th>Packages</th>
                  <th>Amount</th>
                  {pageMode !== "view" && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {biltyList.map((b, i) => (
                  <tr key={i}>
                    <td>{b.bilty_no}</td>
                    <td>{b.consignor_name}</td>
                    <td>{b.consignee_name}</td>
                    <td>{b.no_of_package}</td>
                    <td>{b.total_amount}</td>
                    {pageMode !== "view" && (
                      <td>
                        <button onClick={() => removeBilty(i)}>Remove</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="form-footer">
            <button
              onClick={() => console.log("Values", { pageState, biltyList })}
              type="button"
              className="btn btn-primary"
            >
              Log
            </button>
            {pageMode !== "view" && (
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-primary"
              >
                Save
              </button>
            )}
          </div>
        </div>
      )}

      {viewMode === "list" && (
        <div>
          <h4>Existing Payment Statements</h4>
          <DynamicViewTable
            columns={statementColumns}
            data={statements}
            onRowClick={(row) => handleViewStatement(row.id)}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentStatementForm;
